<template>
    <div class="table table-responsive">
        <table class="table table-responsive table-striped table-bordered d-table">
            <thead>
            <tr>
                <td style="width:15%">Qty</td>
                <td style="width:20%">Make</td>
                <td style="width:20%">Model</td>
                <td style="width:40%">Description</td>
                <td>Delete</td>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(item, itemIndex) in items" :key="item.order">
                    <td>
                        <input :name="'materials['+itemIndex+'][quantity]'" type="number" v-model="item.quantity" @change.prevent="save(item, itemIndex)"
                               class="form-control form-report"/>
                    </td>
                    <td>
                        <input :name="'materials['+itemIndex+'][make]'" type="text" v-model="item.make" @change.prevent="save(item, itemIndex)"
                               class="form-control form-report"/>
                    </td>
                    <td>
                        <input :name="'materials['+itemIndex+'][model]'" type="text" v-model="item.model" @change.prevent="save(item, itemIndex)"
                               class="form-control form-report"/>
                    </td>
                    <td>
                        <input :name="'materials['+itemIndex+'][mat_description]'" type="text" @change.prevent="save(item, itemIndex)"
                               v-model="item.mat_description"
                               class="form-control form-report"/>
                    </td>

                    <td><a @click="deleteLine(item.id, itemIndex)" title="Delete" class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a></td>
                </tr>
            </tbody>
            <tfoot>
            <tr>
                <th colspan="9">
                    <button @click="addLine()" type="button"
                            class="btn btn-sm"
                            data-toggle="tooltip"
                            data-original-title="Add more lines">
                        <i class="fa fa-plus"></i>
                    </button>

                </th>

            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import MaterialComponent from "../../../models/MaterialComponent";
import draggable from 'vuedraggable'
import WorkTicketMaterialModel from "../../../models/WorkTicketMaterialModel";

export default {
    name: "ServiceTicketMaterial",
    components: {
        draggable,
    },
    props: {
        materials: {
            type: Array,
            required: false
        },
        workTicketId: {
            required: true
        },
    },
    data: function () {
        return {
            items: [],
            order: 0,
        }
    },
    mounted() {
        if (this.materials.length > 0) {
            this.items = this.materials
            for (let i = 1; i <= this.items.length; i++) {
                this.items[i - 1]['index'] = i
                this.items[i - 1].order = i
                this.order++;
            }
        }
    },
    methods: {
        addLine() {
            let item = new WorkTicketMaterialModel()
            item.order = ++this.order
            item['index'] = item.order
            this.items.push(item);
        },
        deleteLine(id, itemIndex) {
            let app = this;
            if (id) {
                axios.post(URL_BASE +`/work_tickets/delete-material/${id}`)
                    .then((response)  => {
                        app.items.splice(itemIndex, 1);
                    })
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
        save(item, itemIndex) {
            let app = this;
            if (item.id) {
                axios.post(URL_BASE +`/work_tickets/update-material/${item.id}`, item)
                    .then((response)  => {
                        app.items[itemIndex]  = response.data.data;
                    })
            } else {
                item["work_ticket_id"] = this.workTicketId
                axios.post(URL_BASE +`/work_tickets/store-material`, item)
                    .then((response)  => {
                        app.items[itemIndex]  = response.data.data;
                    })

            }

        },
        checkMove: function () {

            for (let i = 0; i < this.items.length; i++) {
                this.items[i].index = i + 1;
            }
        },
        years: years
    }
}
</script>

<style scoped>
.form-report {
    min-width: 120px;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid !important;
}
</style>
